export default {
  'app.console.nodata': 'No data',
  'app.console.recents': 'Recents',
  'app.console.recents.nodata': 'No data is available. Please activate service first',
  'app.console.channel': 'Service to be activated',
  'app.console.channel.active': 'Service has been opened',
  'app.console.channel.activateService': 'Get Start',
  'app.console.channel.learnMore': 'Learn More',
  'app.console.channel.sendNum': 'Sent',
  'app.console.channel.targetNum': 'Targets',
  'app.console.channel.deliveredNum': 'Delivered',
  'app.console.channel.clickNum': 'Clicks',
  'app.console.channel.readNum': 'Read Quantity',
  'app.console.channel.sendNumRate': 'Sent Rate',
  'app.console.channel.deliveredNumRate': 'Delivery Rate',
  'app.console.channel.clickNumRate': 'CTR',
  'app.console.channel.readNumRate': 'Read Rate',
  'app.console.channel.title1': 'Trend in the past 7 days',
  'app.console.channel.title2': 'Conversion in the last 7 days',
  'app.console.channel.sendOut': 'Send message',
  'app.console.channel.start': 'Get Started',
  'app.console.channel.message.activated': 'activated',
  'app.console.channel.message.apppush':
    'Completing the SDK integration process within just 3 minutes to achieve intelligent and accurate push, effectively improve user activity and retention',
  'app.console.channel.message.email':
    'Provide an efficient and stable email sending API, supporting independent IP configuration, BIMI authentication, and optimizing sending strategies to improve delivery rates through real-time accurate data feedback.',
  'app.console.channel.message.sms':
    'Our integrated SMS message functions combine traditional cellular communication services with the Internet help enterprises become truly globally',
  'app.console.channel.message.whatsapp':
    'Use the WhatsApp Business API to build closer connections with more than two billion global users',
  'app.console.channel.message.OTP':
    'EngageLab OTP provides services for generating and validating one-time passwords, supporting multi-channel delivery through WhatsApp, SMS, Voice, and Email to ensure successful delivery and conversion.',
  'app.console.channel.message.webpush':
    'Instead of relying on mobile apps, you can push marketing messages and service notifications to website subscribers at any time for enhanced user engagement and conversion',
  'app.console.channel.message.edm':
    'One-click installation and no-code required ,your store can easily carry out email marketing and use automation to promote customers to purchase, and  increase revenue',
  'app.console.channel.message.ma':
    'Marketing automation services support managing user data, building user journeys, using multiple channels to reach your users, and providing users with a fast and personalized experience.',
  'app.console.channel.message.captcha':
    'Behavioral CAPTCHA, solving business losses and security risks caused by machine script program automation attacks.',
  'app.console.channel.message.livedesk':
    'AI-driven customer service platform that handles 90% of customer issues perfectly.',
  'app.console.channel.flag.email': 'New Data Center',
  'app.console.doc': 'REST API Docs',
  'app.console.doc.apppush': 'AppPush Docs',
  'app.console.doc.email': 'Email Docs',
  'app.console.doc.sms': 'SMS Docs',
  'app.console.doc.newsms': 'SMS Docs',
  'app.console.doc.whatsapp': 'WhatsApp  Docs',
  'app.console.doc.webpush': 'WebPush  Docs',
  'app.console.doc.edm': 'EDM  Docs',
  'app.console.doc.otp': 'OTP Docs',
  'app.console.doc.ma': 'Marketing Automation Docs',
  'app.console.doc.captcha': 'CAPTCHA Docs',
  'app.console.doc.livedesk': 'LiveDesk Docs',
  'app.console.manage': 'Setting',
  'app.console.manage.orders': 'Orders & Bills',
  'app.console.manage.pending': 'Orders to be paid',
  'app.console.manage.supplementary': 'Bills to be paid',
  'app.console.manage.notification': 'Notification',
  'app.console.manage.faq': 'FAQs',
  'app.console.manage.download': 'Downloads',
  'app.console.channel.verifiedRate': 'Backfilling Rate',
  'app.console.channel.verifiedNum': 'Backfilling Count',
  'app.console.channel.select.all': 'All',
};
